import { render, staticRenderFns } from "./E-logistics.vue?vue&type=template&id=2cb75ca0&"
import script from "./E-logistics.vue?vue&type=script&lang=js&"
export * from "./E-logistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports